/**
 * Utility functions for text processing
 */

/**
 * Converts text URLs into clickable links and ensures all links are styled blue.
 * Handles both plain text and HTML content safely.
 * 
 * @param {string} htmlContent - The HTML or text content to process
 * @returns {string} - processed HTML string with clickable links
 */
export const stripHtml = (html) => {
    if (!html) return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
};

/**
 * Converts text URLs into clickable links and ensures all links are styled blue.
 */
export const linkifyHtml = (htmlContent) => {
    if (!htmlContent) return ""

    // Create a temporary DOM element to parse HTML
    const tempDiv = document.createElement("div")
    tempDiv.innerHTML = htmlContent

    // Recursive function to walk text nodes and existing links
    const walk = (node) => {
        if (node.nodeType === 3) {
            // Text node
            const text = node.nodeValue
            const urlRegex = /(https?:\/\/[^\s]+)/g

            if (urlRegex.test(text)) {
                // Create a wrapper for the new content
                const span = document.createElement("span")
                const parts = text.split(urlRegex)

                parts.forEach((part) => {
                    if (part.match(urlRegex)) {
                        const a = document.createElement("a")
                        a.href = part
                        a.target = "_blank"
                        a.rel = "noopener noreferrer"
                        a.className = "text-blue-600 hover:text-blue-800 underline break-all"
                        a.textContent = part
                        span.appendChild(a)
                    } else {
                        span.appendChild(document.createTextNode(part))
                    }
                })

                node.parentNode.replaceChild(span, node)
            }
        } else if (node.nodeType === 1) {
            // Element node
            if (node.tagName === "A") {
                // Add styles to existing links
                node.classList.add("text-blue-600", "hover:text-blue-800", "underline", "break-all")
                // Set target blank if not set
                if (!node.target) node.target = "_blank"
                if (!node.rel) node.rel = "noopener noreferrer"
            } else {
                // Continue walking children
                Array.from(node.childNodes).forEach(walk)
            }
        }
    }

    walk(tempDiv)
    return tempDiv.innerHTML
};
